import Phaser from "phaser";
import LoadingScene from "@/games/Foraging/scenes/LoadingScene";
import RoundStartScene from "@/games/Foraging/scenes/RoundStartScene";
import QuestionScene from "@/games/Foraging/scenes/QuestionScene";
import PlayScene from "@/games/Foraging/scenes/PlayScene";
import AnsCorrectPlayScene from "@/games/Foraging/scenes/AnsCorrectPlayScene";
import AnsWrongPlayScene from "@/games/Foraging/scenes/AnsWrongPlayScene";
import BossScene from "@/games/Foraging/scenes/BossScene";
import LandingScene from "@/games/Foraging/scenes/LandingScene";
import Settings from "@/games/Settings";

function launch(containerId) {
  return new Phaser.Game({
    type: Phaser.AUTO,
    backgroundColor: 0xf5f5f5,
    parent: containerId,
    scale: {
      parent: containerId,
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 480,
      height: 854,
    },
    physics: {
      default: "arcade",
    },
    dom: {
      createContainer: true,
    },
    scene: [
      LoadingScene,
      RoundStartScene,
      QuestionScene,
      PlayScene,
      AnsCorrectPlayScene,
      AnsWrongPlayScene,
      BossScene,
      Settings,
      LandingScene,
    ],
  });
}

export default launch;
export { launch };
